import Vue from 'vue'
import { UWMOTOR_INIT_SUCCESS, UWMOTOR_INIT_FAIL, UWMOTOR_INIT_LOADING,
  UWMOTOR_LOAD_PERMITSTATUSLIST, UWMOTOR_LOAD_BODYTYPELIST, UWMOTOR_LOAD_MAKELIST, UWMOTOR_LOAD_GROUPLIST,
  MTRNCD_INIT_SUCCESS, MTRNCD_INIT_FAIL, MTRNCD_INIT_LOADING } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  mtrNCD: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const getters = {

}

const mutations = {
  [UWMOTOR_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [UWMOTOR_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [UWMOTOR_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [MTRNCD_INIT_LOADING](state) {
    state.mtrNCD.init = 0
    state.mtrNCD.menu = {}
    state.mtrNCD.initErr = []
  },
  [MTRNCD_INIT_SUCCESS](state, data) {
    state.mtrNCD.init = 1
    state.mtrNCD.menu = data ? data.menu : null
    state.mtrNCD.initErr = []
  },
  [MTRNCD_INIT_FAIL](state, err) {
    state.mtrNCD.init = 2
    state.mtrNCD.menu = {}
    state.mtrNCD.initErr = err
  },
  [UWMOTOR_LOAD_PERMITSTATUSLIST](state, data) {
    Vue.set(state, 'permitStatusList', data)
  },
  [UWMOTOR_LOAD_BODYTYPELIST](state, data) {
    Vue.set(state, 'bodyTypeList', data)
  },
  [UWMOTOR_LOAD_MAKELIST](state, data) {
    Vue.set(state, 'makeList', data)
  },
  [UWMOTOR_LOAD_GROUPLIST](state, data) {
    Vue.set(state, 'groupList', data)
  }
}

const actions = {
  async uwMotorManagementInit({ commit, rootState }) {
    commit(UWMOTOR_INIT_LOADING)
    try {
      const apiUrl = rootState.app.menu.uwMotorManagement
      if (apiUrl) {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(UWMOTOR_INIT_SUCCESS, commitResult)
      }
      const apiURLPermitStatus = state.menu.permitStatusList
      if (apiURLPermitStatus) {
        const result = await http.get(apiURLPermitStatus)
        commit(UWMOTOR_LOAD_PERMITSTATUSLIST, result.data.data.permitStatusList)
      }
      const apiURLBodyTypeList = state.menu.bodyTypeList
      if (apiURLBodyTypeList) {
        const result = await http.get(apiURLBodyTypeList)
        commit(UWMOTOR_LOAD_BODYTYPELIST, result.data.data.bodyTypeList)
      }
      const apiURLMakeList = state.menu.makeList
      if (apiURLMakeList) {
        const result = await http.get(apiURLMakeList)
        commit(UWMOTOR_LOAD_MAKELIST, result.data.data.makeList)
      }
      const apiURLGroupList = state.menu.groupList
      if (apiURLGroupList) {
        const result = await http.get(apiURLGroupList)
        commit(UWMOTOR_LOAD_GROUPLIST, result.data.data.groupList)
      }
    } catch (error) {
      commit(UWMOTOR_INIT_FAIL, extractMessages(error))
    }
  },
  async MtrNCDInit({ commit, state }) {
    const apiUrl = state.menu.MtrNCDInit
    commit(MTRNCD_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(MTRNCD_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(MTRNCD_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
